import { css } from '@emotion/css';
import { Color, Styles } from 'css/theme';
import React, { MouseEvent } from 'react';

interface Item<T extends { id: string }> {
  text: string;
  value: T;
  onClick: (event: MouseEvent) => {};
}

interface Props<T extends { id: string }> {
  items: Array<Item<T>>;
}

const wrapper = css({
  borderRadius: Styles.BorderRadius,
  background: Color.White,
  boxShadow: '0px 10px 30px rgba(209, 213, 223, 0.5)',
  borderColor: Color.BackgroundGray,
  borderWidth: '1px',
});

const itemWrapper = css({
  cursor: 'pointer',
  minWidth: '150px',
  borderRadius: Styles.BorderRadius,
  ':hover': {
    backgroundColor: Color.LightBlue,
    color: Color.PrimaryBlue,
  },
});

const buttonWrapper = css({
  width: '100%',
  fontWeight: 500,
  padding: '16px',
  textAlign: 'left',
});

function MenuList<T extends { id: string }>({ items }: Props<T>, ref) {
  return (
    <ul ref={ref} className={wrapper}>
      {items.map(i => (
        <li className={itemWrapper} key={i.value.id}>
          <button className={buttonWrapper} onClick={i.onClick}>
            {i.text}
          </button>
        </li>
      ))}
    </ul>
  );
}

export default React.forwardRef(MenuList);
